document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-draggable-tabs]');
  if (!container) return;

  const listWrapper = container.querySelector(
    '.product-sibling-terms__list-wrapper',
  );
  const list = container.querySelector('.product-sibling-terms__list');
  const prevBtn = container.querySelector(
    '.product-sibling-terms__scroll--prev',
  );
  const nextBtn = container.querySelector(
    '.product-sibling-terms__scroll--next',
  );

  if (!list || !prevBtn || !nextBtn || !listWrapper) return;

  // Check if scrolling is needed
  function checkScrollNeeded() {
    const isScrollable = list.scrollWidth > list.clientWidth;

    // Show/hide arrows based on whether scrolling is needed
    if (isScrollable) {
      prevBtn.classList.add('visible');
      nextBtn.classList.add('visible');
      // Enable drag functionality
      list.style.cursor = 'grab';
    } else {
      prevBtn.classList.remove('visible');
      nextBtn.classList.remove('visible');
      // Disable drag functionality
      list.style.cursor = 'default';
      // Remove fade effects
      listWrapper.classList.remove('has-scroll-left', 'has-scroll-right');
    }

    return isScrollable;
  }

  // Update scroll button states and fade effects
  function updateScrollState() {
    const isScrollable = checkScrollNeeded();
    if (!isScrollable) return;

    const maxScroll = list.scrollWidth - list.clientWidth;
    const currentScroll = list.scrollLeft;

    // Update button states
    prevBtn.disabled = currentScroll <= 0;
    nextBtn.disabled = currentScroll >= maxScroll;

    // Update fade effects
    listWrapper.classList.toggle('has-scroll-left', currentScroll > 5);
    listWrapper.classList.toggle(
      'has-scroll-right',
      currentScroll < maxScroll - 5,
    );
  }

  // Scroll button functionality
  prevBtn.addEventListener('click', () => {
    if (checkScrollNeeded()) {
      list.scrollBy({ left: -150, behavior: 'smooth' });
    }
  });

  nextBtn.addEventListener('click', () => {
    if (checkScrollNeeded()) {
      list.scrollBy({ left: 150, behavior: 'smooth' });
    }
  });

  // Slider functionality
  let isDown = false;
  let startX;
  let scrollLeft;
  let startTime;
  let hasMoved = false;

  // Prevent link dragging
  list.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });

  // Mouse events
  list.addEventListener('mousedown', (e) => {
    // Only enable dragging if scrolling is needed
    if (!checkScrollNeeded()) return;

    isDown = true;
    startTime = Date.now();
    hasMoved = false;
    list.style.cursor = 'grabbing';
    list.style.userSelect = 'none';

    const { pageX } = e;
    const { offsetLeft, scrollLeft: currentScrollLeft } = list;
    startX = pageX - offsetLeft;
    scrollLeft = currentScrollLeft;

    // Prevent text selection and link dragging
    e.preventDefault();
  });

  list.addEventListener('mouseleave', () => {
    isDown = false;
    if (checkScrollNeeded()) {
      list.style.cursor = 'grab';
    }
    list.style.userSelect = '';
  });

  list.addEventListener('mouseup', (e) => {
    isDown = false;
    if (checkScrollNeeded()) {
      list.style.cursor = 'grab';
    }
    list.style.userSelect = '';

    // If it was a quick click without much movement, allow link navigation
    const timeDiff = Date.now() - startTime;
    if (!hasMoved && timeDiff < 300 && e.target.tagName === 'A') {
      // Trigger link navigation programmatically
      window.location.href = e.target.href;
      return;
    }

    // Always prevent default to avoid any unwanted navigation
    if (hasMoved) {
      e.preventDefault();
    }
  });

  list.addEventListener('mousemove', (e) => {
    if (!isDown || !checkScrollNeeded()) return;

    e.preventDefault();
    const { pageX } = e;
    const x = pageX - list.offsetLeft;
    const walk = (x - startX) * 1.2;

    // Mark that we've moved significantly (reduced threshold)
    if (Math.abs(walk) > 3) {
      hasMoved = true;
    }

    list.scrollLeft = scrollLeft - walk;
  });

  list.addEventListener('touchstart', (e) => {
    if (!checkScrollNeeded()) return;

    isDown = true;
    startTime = Date.now();
    hasMoved = false;

    const { pageX } = e.touches[0];
    const { offsetLeft, scrollLeft: currentScrollLeft } = list;
    startX = pageX - offsetLeft;
    scrollLeft = currentScrollLeft;

    e.preventDefault();
  });

  list.addEventListener('touchmove', (e) => {
    if (!isDown || !checkScrollNeeded()) return;

    const { pageX } = e.touches[0];
    const x = pageX - list.offsetLeft;
    // Reduced multiplier for smoother feel
    const walk = (x - startX) * 1.2;

    if (Math.abs(walk) > 3) {
      hasMoved = true;
    }

    list.scrollLeft = scrollLeft - walk;

    // Prevent page scrolling while sliding
    e.preventDefault();
  });

  list.addEventListener('touchend', (e) => {
    if (!checkScrollNeeded()) return;

    isDown = false;

    const timeDiff = Date.now() - startTime;
    if (!hasMoved && timeDiff < 300 && e.target.tagName === 'A') {
      // Trigger link navigation for touch
      e.target.click();
      return;
    }

    // Prevent any unwanted behaviors
    if (hasMoved) {
      e.preventDefault();
    }
  });

  // Prevent context menu on right click while dragging
  list.addEventListener('contextmenu', (e) => {
    if (hasMoved) {
      e.preventDefault();
    }
  });

  // Listen for scroll events
  list.addEventListener('scroll', updateScrollState);

  // Initial state setup
  updateScrollState();

  // Update on window resize
  window.addEventListener('resize', () => {
    setTimeout(updateScrollState, 100);
  });
});
